type FbqFunction = {
  (...args: unknown[]): void
  callMethod?: (...args: unknown[]) => void
  queue: unknown[][]
  push: FbqFunction
  loaded: boolean
  version: string
}

declare global {
  interface Window {
    fbq?: FbqFunction
    _fbq?: FbqFunction
  }
}

export const META_PIXEL_ID = '2969306426756951'

/**
 * Carga Meta Pixel. SOLO debe llamarse tras el consentimiento de cookies de publicidad.
 */
export function initMetaPixel(): void {
  if (typeof window === 'undefined') return
  if (window.fbq) {
    window.fbq('consent', 'grant')
    return
  }

  const fbq = function (...args: unknown[]) {
    if (fbq.callMethod) {
      fbq.callMethod(...args)
    } else {
      fbq.queue.push(args)
    }
  } as FbqFunction

  fbq.queue = []
  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'

  window.fbq = fbq
  if (!window._fbq) window._fbq = fbq

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  window.fbq('consent', 'grant')
  window.fbq('init', META_PIXEL_ID)
  window.fbq('track', 'PageView')
}

/**
 * Retira el consentimiento: detiene el envío de datos y elimina las cookies de Meta del dominio.
 */
export function revokeMetaPixel(): void {
  if (typeof window === 'undefined') return
  if (window.fbq) window.fbq('consent', 'revoke')
  deleteCookies(['_fbp', '_fbc'])
}

function deleteCookies(names: string[]): void {
  const parts = window.location.hostname.split('.')
  const domains: string[] = ['']
  for (let i = 0; i < parts.length - 1; i += 1) {
    domains.push(`.${parts.slice(i).join('.')}`)
  }
  names.forEach((name) => {
    domains.forEach((domain) => {
      document.cookie = `${name}=; Max-Age=0; path=/${domain ? `; domain=${domain}` : ''}`
    })
  })
}
